module.exports = __webpack_public_path__ + "static/media/logo.c335bf61.webp";